module.exports = __webpack_public_path__ + "onset-instructions-1.gif?b0ae8cbf147c86d9150434d4f124e27b";